import { useEffect } from "react";
import { IndentWrapper } from "../../features/orderConfiguration/OrderConfiguration"
import Input, { DashboardCheckbox, DashboardToggleSwitch, InputList } from "../Input/InputNew"
import QuestionHeading from "../heading/QuestionHeading"
import { UiConfigImageUpload } from "./UiConfigImageUpload";
import { ColorPicker, CustomRadio, CustomSelect, LabelInput, MultiCheckBox, MultiImage,  RelatedDashboardSelect, Track, TrackOrder } from "./GenericConfigComponentsNew";
import { Box } from "@mui/material";
import QuestionHeadingNew from "../heading/QuestionHeadingNew";
import { AntAnchor } from "antd/es/anchor/Anchor";

interface Props {
    sx: any,
    heading: string;
    type: "checkbox" | "textfield" | "select" | "image" | "relatedSelect" | "multipleCheckbox" | "imageList" | "colorInput" | "labelInput" | "textfieldList" | "track" | "trackOrder"|"toggle"|"radio";
    values: any;
    setValues: any;
    name: string;
    validations?: any;
    value?: any;
    description:string;
    setAreDataFieldsValid?:(isValid: boolean) => void;
    updateState:(key:any,newValue:any,values:any)=>void
}
export function GenericUIComponentNew(props: Props) {
    const handleChange = (name: string, value: any, values: any, setValues: any,validations?:any) => {
  
        if(props?.validations?.textType==="number"){
            value=parseInt(value)
        }
        const keys = name.split('.');
        
        if (keys.length > 1) {
            if (Array.isArray(values[keys[0]].value)) {
                const updatedArray = [...values[keys[0]].value];
                updatedArray[0] = {
                    ...updatedArray[0],
                    [keys[1]]: value
                };
                const updatedValues=props.updateState(keys[0],updatedArray,values);
               setValues(updatedValues)
            } else {
                const updatedValues=props.updateState(keys[0],values[keys[0]].value,values);
               setValues(updatedValues)
        
            }
        } else {
            const updatedValues=props.updateState(name,value,values);
            setValues(updatedValues)
           
        }
       
    }
    function setBlobkey(blobKey: any) {
         const updatedValues=props.updateState(props?.name,blobKey,props.values);
            props.setValues(updatedValues)
    }

    const handleImageListChange = (index: number, blobKey: any) => {
      
        const updatedImageList = [...(props.values[props.name]?.value || [])];
        updatedImageList[index] = blobKey;
        const updatedValues=props.updateState(props?.name,updatedImageList,props.values);
        props.setValues(updatedValues)
        
    };


    const getValue = (values:any, name:any) => {
    const keys = name.split('.');
    let nestedValue = values;
    if (keys.length > 1) {
        nestedValue = nestedValue?.[keys?.[0]].value[0]?.[keys?.[1]];
    } else {
        nestedValue = values?.[name]?.value;
    }
    return nestedValue;
    };
    const renderComponent = () => {
        switch (props.type) {
            case "checkbox":
                return (
                    <div className="answer_container_new">
                        <DashboardCheckbox
                            onChange={(e) => { handleChange(e.target.name, e.target.checked, props.values, props.setValues) }}
                            checked={props.values[props?.name]?.value}
                            name={props?.name}
                            label={props?.validations?.label ?? ""}
                        />
                    </div>
                );
                 case "toggle":
                return (
                    
                    <div style={{display:"flex",justifyContent:"left"}} >
                       
                        <DashboardToggleSwitch
                       key={props.name}
                             onChange={(_, checked) =>
    handleChange(props.name, checked, props.values, props.setValues)
  }
                            checked={props.values[props?.name]?.value}
                            name={props?.name}
                            label={props?.validations?.label ?? ""}
                        />
                    </div>
                );
            case "textfield":
                return (
                    <div className="answer_container_new">
                        <Input
                            value={getValue(props.values, props.name)}
                            onChange={(e) => { handleChange(e.target.name, e.target.value, props.values, props.setValues,props.validations) }}
                            name={props?.name}
                            type={props?.validations?.textType}
                            regex={props?.validations?.regex}
                            setAreDataFieldsValid={props?.setAreDataFieldsValid}
                            suffix={props?.validations?.suffix}
                            width={props?.validations?.width}
                            minimumValue={props?.validations?.minimumValue}
                            maximumValue={props?.validations?.maximumValue}
                        />
                    </div>
                );

            case "select":
                return (
                    <CustomSelect key={props.name} values={props.values} setValues={props.setValues} name={props.name} updateState={props.updateState} extendedAttributes={props.validations?.options}  />
                );
           case 'radio':
            return (
 <CustomRadio key={props.name} values={props.values} setValues={props.setValues} name={props.name} updateState={props.updateState} extendedAttributes={props.validations?.options} setAreDataFieldsValid={props?.setAreDataFieldsValid}  />
            )
            case "image":
                return (
                    <div className="answer_container_new" style={{ width: "100%" }}>
                        <UiConfigImageUpload
                            resolution={{
                                height: Number(props?.validations?.height),
                                width: Number(props?.validations?.width)
                            }}
                            max={props?.validations?.max}
                            maxSizeKB={props?.validations?.maxSizeKB}
                            label={props?.validations?.label}
                            defaultFile={props.values[props?.name]?.value}
                            setDefaultFile={setBlobkey}
                            accept={{
                                image: ["png", "jpeg", "jpg"],
                            }}
                            fetchBlobKey={true}
                            errorMessage={!props.values[props?.name]?.value ? "Please upload Image" : ""}
                        />
                    </div>
                );
            case "relatedSelect":
                return (
                    <>
                        <RelatedDashboardSelect key={props.name} element={props.validations} />
                    </>
                );
            case "multipleCheckbox":
                return (
                    <div className="language_options_container" style={{padding:"0"}}>
                        <MultiCheckBox name={props.name} values={props.values} setValues={props.setValues} element={props.validations} />
                    </div>
                );

            case "imageList":
                return (
                    <MultiImage
                        key={props.name}
                        name={props.name}
                        values={props.values[props?.name]?.value}
                        setValues={props.setValues}
                        extendedAttributes={props.validations}
                        handleImageListChange={handleImageListChange}
                        max={props?.validations?.max}
                    />
                );
            case "colorInput":
                return (
                     
                        <ColorPicker name={props.name} values={props.values} setValues={props.setValues} updateState={props.updateState} />
                ); 
            case "labelInput":
                return (
                        <LabelInput name={props.name} values={props.values} setValues={props.setValues} />
                );
                
            case "track":
                return (
                        <Track name={props.name} values={props.values} setValues={props.setValues}/>
                );
            case "trackOrder":
                return (
                        <TrackOrder name={props.name} values={props.values} setValues={props.setValues} extendedAttributes={props.validations} />
                );      
            case "textfieldList":
                return (
                        <InputList question={props.heading} configName={props.name} values={props.values} setValues={props.setValues} updateState={props.updateState} />
            );  
          
            default:
                return null;
        }
    }

    return (
        
        <Box sx={props.sx}>
            {props.type === "toggle" ? (
  <Box sx={{ display: "flex", alignItems: "center" }}>
    <QuestionHeadingNew
      type={props.type}
      description={props?.description ?? ""}
      required={props?.validations?.required}
    >
      {props.heading}
    </QuestionHeadingNew>

    <Box sx={{ ml: "27px" }}>
      {renderComponent()}
    </Box>
  </Box>
) : (
  <>
    {props.type !== "textfieldList" && (
      <QuestionHeadingNew
        type={props.type}
        description={props?.description ?? ""}
        required={props?.validations?.required}
      >
        {props.heading}
      </QuestionHeadingNew>
    )}
    {renderComponent()}
  </>
)}

        </Box>
    );
}

